export default __webpack_public_path__ + "static/media/hero-1.5f2d829c.png";